import type { ReactNode } from "react"
import { InlineMessage } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { t } from "i18next"
import type { CallcenterLocalizationKeys } from "@callcenter/locales/types/Callcenter.types"
import { $callcenterService } from "@callcenter/effector-services"

import { $isActiveTrial } from "../../models/self-service.model"

import styles from "./styles.module.pcss"

export type TrialLimitationsSection = "cdr" | "users" | "numbers" | "digitalChannels" | "queues" | "teams" | "flows"

const SECTION_I18N_KEY: Record<TrialLimitationsSection, keyof CallcenterLocalizationKeys> = {
  cdr: "cdr_trialLimitations_message",
  users: "users_trialLimitations_message",
  numbers: "numbers_trialLimitations_message",
  digitalChannels: "channels_trialLimitations_message",
  queues: "queues_trialLimitations_message",
  teams: "teams_trialLimitations_message",
  flows: "flows_trialLimitations_message"
}

const SECTION_TEST_ID: Record<TrialLimitationsSection, string> = {
  cdr: "trial-limitations-banner-cdr",
  users: "trial-limitations-banner-users",
  numbers: "trial-limitations-banner-numbers",
  digitalChannels: "trial-limitations-banner-digital-channels",
  queues: "trial-limitations-banner-queues",
  teams: "trial-limitations-banner-teams",
  flows: "trial-limitations-banner-flows"
}

type Props = {
  section: TrialLimitationsSection
  children?: ReactNode
}

export const TrialLimitationsBanner = ({ section, children }: Props) => {
  const isActiveTrial = useUnit($isActiveTrial)
  const settings = useUnit($callcenterService.$settings)

  if (!isActiveTrial) {
    return null
  }

  return (
    <div className={styles.wrapper} data-testid={SECTION_TEST_ID[section]}>
      <InlineMessage type="promo">
        {children ??
          t(SECTION_I18N_KEY[section], {
            trialNumber: settings.self_service_trial_number?.number ?? "",
            country: settings.self_service_trial_number?.country ?? ""
          })}
      </InlineMessage>
    </div>
  )
}
